import React, { useState } from 'react'
import { ContactInfoCard } from './ContactInfoCard'
import nodata from "../../../Utils/assets/img/leads_no_data_found_removebg.png"
import { Pagination } from '../../../CommonComponents/Pagination'
import DeleteModal from '../../DeleteModal'

export const ContactCardListing = ({
    hasDataToDisplay,
    dataToDisplay,
    effectivePageCount,
    displayStartItem,
    displayEndItem,
    totalItems,
    offset,
    setOffset,
    handlePageChange,
    setActiveCard,
    // setContactId,
    // setShowContactDetailsCanvas,
    setShowId,
    setLimit,
    setConfirmDeleteId,
    setShowDeleteModal,
    handleDeleteContact
}) => {

    return <>
        {
            hasDataToDisplay ?
                <>
                    <hr />
                    <div className="row position-relative">
                        {dataToDisplay?.map((contact, index) => {
                            const contactIds = dataToDisplay.map(({ id }) => id)
                            return (
                                <React.Fragment key={contact.id}>
                                    <ContactInfoCard
                                        key={contact.id}
                                        contactIds={contactIds}
                                        contact={contact}
                                        setActiveCard={setActiveCard}
                                        setConfirmDeleteId={setConfirmDeleteId}
                                        // setContactId={setContactId}
                                        // setShowContactDetailsCanvas={setShowContactDetailsCanvas}
                                        setShowDeleteModal={setShowDeleteModal}
                                        setShowId={setShowId}
                                    />
                                </React.Fragment>
                            )
                        })}
                        {dataToDisplay?.length >= 1 && effectivePageCount > 1 && (
                            <div
                                style={{
                                    padding: "0.5rem 0",
                                    backgroundColor: "white",
                                    borderTop: "1px solid #e0e0e0",
                                    overflowX: "auto",
                                    width: "100%",
                                    position: dataToDisplay?.length < 20 && "fixed",
                                    bottom: dataToDisplay?.length < 20 && "4rem",
                                }}
                            >
                                <div className="d-flex justify-content-between align-items-center gap-2">
                                    <div className="pagination-left">
                                        <p className="mb-0" style={{ fontSize: "14px" }}>
                                            Showing {displayStartItem}-{displayEndItem} of {totalItems} items
                                        </p>
                                    </div>
                                    <div className="pagination-right d-flex gap-2 align-items-center">
                                        <select
                                            style={{ minWidth: "78px", height: "2.3rem" }}
                                            onChange={(e) => {
                                                setLimit(Number(e.target.value))
                                                setOffset(0)
                                            }}
                                            id="limit"
                                            className="form-control form-select"
                                        >
                                            <option value={20}>20</option>
                                            <option value={100}>100</option>
                                            <option value={200}>200</option>
                                            <option value={300}>300</option>
                                        </select>
                                        <div className="d-flex align-items-center gap-3">
                                            <Pagination
                                                offset={offset}
                                                setOffset={setOffset}
                                                handlePageChange={handlePageChange}
                                                pageCount={effectivePageCount}
                                            />
                                        </div>
                                    </div>
                                </div>
                            </div>
                        )}
                    </div>
                </>
                :
                <>
                    {/* No Data Found */}
                    <div
                        className="d-flex justify-content-center align-items-center"
                        style={{ position: "absolute", left: "42%" }}
                    >
                        <img
                            src={nodata}
                            alt="nodata_found_img"
                            style={{ width: "17rem", marginTop: "0" }}
                        />
                    </div>
                </>
        }
    </>
}